import { DriverOption } from "@src/shipments/components/DriverFilterSelector";

export const sortDriversByName = (drivers: DriverOption[]) => {
  return drivers.sort((a, b) => a.name.localeCompare(b.name));
};
